module.exports = __webpack_public_path__ + "img/Azrtx b  oard – 2.2d32ccb5.png";